/**
 * @category  ScandiPWA
 * @author    Kristers Cams <kristers.cams@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

import { showNotification } from 'Store/Notification/Notification.action';
import BrowserDatabase from 'Util/BrowserDatabase';
import { QueryDispatcher } from 'Util/Request';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';

import ProductLabelSettingQuery from '../../../query/ProductLabelSetting.query';
import { updateProductLabelSetting } from './ProductLabelSetting.action';

/** @namespace ScandipwaAmastyLabels/Store/ProductLabel/ProductLabelSetting/Dispatcher */
export class ProductLabelSettingDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct('amLabelSetting');
    }

    onSuccess(data, dispatch) {
        if (data) {
            BrowserDatabase.setItem(data, 'amLabelSetting', ONE_MONTH_IN_SECONDS);
            dispatch(updateProductLabelSetting(data));
        }
    }

    onError(error, dispatch) {
        dispatch(showNotification('error', __('Error fetching configuration, please refresh!'), error));
    }

    prepareRequest() {
        return [
            ProductLabelSettingQuery.getQuery()
        ];
    }
}

export default new ProductLabelSettingDispatcher();
